export default{
    baseUrl:'https://www.taiqiu123.com',
    //时间戳转日期
    timetrans(date, isAll = false, Y = "年", M = "月", D = "日") {
        var date = parseInt(date);
        date = date.toString().length == 13 ? new Date(date) : new Date(date * 1000); 
        Y = date.getFullYear() + Y
        M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + M
        D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + D + '\t'
        if (isAll) {
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

            return Y + M + D + h + m;
        } else {
            return Y + M + D;
        }
    },
}